<lib-nous-contacter [configuration]="configuration" [fileLimit]="MAX_FILE_SELECT" [fileMaxSize]="MAX_FILE_SIZE"[fileNamePattern]="fileNamePattern"></lib-nous-contacter>
